import { getTranslations } from "next-intl/server";
import { HERO_PAGES } from "./hero-pages";
import { HERO_ART } from "./hero-art";
import { HeroView } from "./hero-view";

export async function Hero() {
  const t = await getTranslations("hero");
  const pages = HERO_PAGES.map((key) => ({ title: t(`pages.${key}.title`), body: t(`pages.${key}.body`), art: HERO_ART[key] }));
  const actions = [{ label: t("actions.services"), href: "#services" }, { label: t("actions.start"), href: "#start" }];
  return <HeroView pages={pages} actions={actions} />;
}

/** The brand-coloured field behind a full-screen page: a radial depth, nothing moving. */
export function HeroStage() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 -z-20 bg-[radial-gradient(ellipse_at_50%_45%,color-mix(in_oklab,var(--brand)_80%,white)_0%,var(--brand)_38%,color-mix(in_oklab,var(--brand)_35%,black)_100%)]" />
  );
}
